import type { IBaseItem } from '@shiftsmartinc/shiftsmart-types';

import _ from 'lodash';

import BaseStore from './_baseStore';

export type IUserStat = IBaseItem & Record<string, unknown>;

export default class UserStatStore extends BaseStore<IUserStat> {
  constructor() {
    const baseItem = {
      adherence: null,
      attendance: null,
      company: null,
      hoursPerWeek: null,
      messageRead: null,
      onTime: null,
      openShiftPickup: null,
      rating: null,
      ratingCt: null,
      reliability: null,
      shiftCt: null,
      user: null,
      uuid: null,
    };
    super({
      baseItem,
      serviceName: 'userstats',
    });

    this.selected = _.clone(this.baseItem);

    return this;
  }
}
